import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Box, Copy, Icon, Image, useMediaQueries } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import { useTranslation } from 'react-i18next';

import Context from './service/Context';
import LocalStorageContext from '../LocalStorageContext/LocalStorageContext';
import themeStyles from './ScrollableDrawerCards.styles';
import { PSP_SITE_NAME } from '../../utils/constants';
import { useAppName } from '../../utils/sitecoreContext';

const EmptyCard = themeStyles.apply(Box, 'EmptyCard');
const ModelCard = themeStyles.apply(Box, 'ModelCard');
const CardTitle = themeStyles.apply(Copy, 'CardTitle');
const CardImage = themeStyles.apply(Image, 'CardImage');
const IconWrapper = themeStyles.apply(Box, 'IconWrapper');
const CardWrapper = themeStyles.apply(Box, 'CardWrapper');

const HorizontalProductCard = ({ empty, fields, firstProduct }) => {
  const { t } = useTranslation();
  const { removeFromCompareProducts, toCompareProducts } = useContext(LocalStorageContext);
  const { hasCategories, addToCompareLabel } = useContext(Context) || {};
  const appName = useAppName();
  const { isMobile } = useMediaQueries();

  if (empty) {
    return (
      <ModelCard tabIndex={0}>
        <EmptyCard>
          {hasCategories
            ? t(addToCompareLabel, { categorySingularName: firstProduct?.categorySingularName })
            : t(`Shared.Common.add${firstProduct}ToCompareLabel`)}
        </EmptyCard>
      </ModelCard>
    );
  }

  const { modelName, modelPage, primaryThumbnail, detIdentifier } = fields;
  const modelPageUrl = modelPage?.field?.fields?.url;
  const alt = primaryThumbnail?.item?.value?.alt;
  const image = primaryThumbnail?.item?.value?.src;
  const detId = detIdentifier?.value;

  const removeFromDrawer = () => {
    if (appName === PSP_SITE_NAME) {
      const toCompareProductsSet = new Set(toCompareProducts.map(product => product.detId).filter(Boolean));
      (fields?.transmissions ?? []).forEach(transmissionId => {
        if (!toCompareProductsSet.has(transmissionId)) return;
        removeFromCompareProducts(transmissionId);
      });
      return;
    }
    removeFromCompareProducts(detId);
  };

  return (
    <ModelCard tabIndex={0} data-testid="compare-drawer-product-card">
      <CardWrapper>
        <CardImage src={image} alt={alt} />
        <CardTitle as="a" href={modelPageUrl}>
          {compiler(modelName?.value)}
        </CardTitle>
      </CardWrapper>
      <IconWrapper data-testid="compare-drawer-product-card-close-btn" tabIndex={0} onClick={removeFromDrawer}>
        <Icon name="close" iconSize={isMobile ? 'small' : 'default'} />
      </IconWrapper>
    </ModelCard>
  );
};

HorizontalProductCard.propTypes = {
  empty: PropTypes.bool,
  fields: PropTypes.shape({
    modelPage: PropTypes.shape({
      field: PropTypes.shape({
        fields: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    detIdentifier: PropTypes.shape({
      value: PropTypes.string,
    }),
    modelName: PropTypes.shape({
      value: PropTypes.string,
    }),
    primaryThumbnail: PropTypes.shape({
      item: PropTypes.shape({
        value: PropTypes.shape({
          src: PropTypes.string,
          alt: PropTypes.string,
        }),
      }),
    }),
  }),
};

export default HorizontalProductCard;
